import { TagManager } from 'components'
import { useGetQuery } from 'hooks'
import { useParams } from 'react-router-dom'

export const AdminCategoriesShow = () => {
  const { slug } = useParams()
  const { data, reFetch } = useGetQuery({ url: `/admin/categories/${slug}` })
  const updatePlace = () => {
    reFetch()
  }
  return (
    <div>
      show {data?.categories?.name}
      <TagManager
        onTagUpdate={updatePlace}
        item_id={data?.categories?.id}
        item_type="category"
        tags={data?.categories?.Tags}
      />
    </div>
  )
}
